var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parse as parseYaml } from 'yaml';
import { InputSpec as FilterSpecInput } from './FilterTypesSpec';
import { BooleanInputSpec, EnumListInputSpec, InputSpec, NumberInputSpec, StringListInputSpec, StyleInputSpec, TextInputSpec, } from './UiTypesSpec';
import { TokenType } from './token';
import { TokenStreamError } from './tokenstream';
export var parseInput = function (comment, define) {
    var declarationContent = comment.substring(comment.indexOf('\n'), // chop the structured declaration
    comment.indexOf('*/'));
    define.takeExpect(TokenType.PREPROC_DEFINE);
    var macroName = define.takeExpect(TokenType.IDENTIFIER).value;
    var declaration = parseYaml(declarationContent);
    if (declaration.default !== undefined) {
        throw new Error('input declaration must not have a default');
    }
    var baseInput = __assign(__assign({}, FilterSpecInput.parse(declaration)), { macroName: macroName });
    var input = InputSpec.parse(baseInput);
    // validate the input with a default field; to check that the default field is correct
    switch (input.type) {
        case 'boolean':
            input.default = define.takeBool();
            return BooleanInputSpec.parse(input);
        case 'number':
            input.default = define.takeInt();
            return NumberInputSpec.parse(input);
        case 'stringlist':
            input.default = define.takeStringList();
            return StringListInputSpec.parse(input);
        case 'enumlist':
            input.default = define.takeStringList();
            return EnumListInputSpec.parse(input);
        case 'style':
            input.default = parseStyle(define);
            return StyleInputSpec.parse(input);
        case 'text':
            input.default = define.takeString();
            return TextInputSpec.parse(input);
        default:
            throw new Error("Invalid input type: ".concat(input.type));
    }
};
var parseStyle = function (tokens) {
    var style = {};
    while (tokens.hasTokens()) {
        var ident = tokens.takeExpect(TokenType.IDENTIFIER);
        tokens.takeExpect(TokenType.ASSIGN);
        switch (ident.value) {
            case 'color':
            case 'textColor': // zod validates that these are color strings
                style.textColor = tokens.takeString();
                break;
            case 'backgroundColor':
                style.backgroundColor = tokens.takeString();
                break;
            case 'borderColor':
                style.borderColor = tokens.takeString();
                break;
            case 'hidden':
                style.hidden = tokens.takeBool();
                break;
            case 'showLootbeam':
            case 'showLootBeam':
                style.showLootbeam = tokens.takeBool();
                break;
            case 'showValue':
                style.showValue = tokens.takeBool();
                break;
            case 'showDespawn':
                style.showDespawn = tokens.takeBool();
                break;
            case 'notify':
                style.notify = tokens.takeBool();
                break;
            case 'textAccent':
                style.textAccent = tokens.takeInt();
                break;
            case 'textAccentColor':
                style.textAccentColor = tokens.takeString();
                break;
            case 'lootbeamColor':
            case 'lootBeamColor':
                style.lootbeamColor = tokens.takeString();
                break;
            case 'fontType':
                style.fontType = tokens.takeInt();
                break;
            case 'menuTextColor':
                style.menuTextColor = tokens.takeString();
                break;
            case 'highlightTile':
                style.highlightTile = tokens.takeBool();
                break;
            case 'tileStrokeColor':
                style.tileStrokeColor = tokens.takeString();
                break;
            case 'tileFillColor':
                style.tileFillColor = tokens.takeString();
                break;
            case 'hideOverlay':
                // we recognize this but the site doesn't support it
                tokens.takeBool();
                break;
            case 'sound':
                var value = tokens.peek();
                if (value.type === TokenType.LITERAL_INT) {
                    style.sound = tokens.takeInt();
                }
                else if (value.type === TokenType.LITERAL_STRING) {
                    style.sound = tokens.takeString();
                }
                else {
                    throw new TokenStreamError('invalid sound value', value);
                }
                break;
            case 'menuSort':
                style.menuSort = tokens.takeInt();
                break;
            case 'icon':
                style.icon = parseStyleIcon(tokens);
                break;
            default:
                throw new TokenStreamError('invalid style property', ident);
        }
        tokens.takeExpect(TokenType.STMT_END);
    }
    return style;
};
var parseStyleIcon = function (tokens) {
    var exprName = tokens.takeExpect(TokenType.IDENTIFIER);
    tokens.takeExpect(TokenType.EXPR_START);
    switch (exprName.value) {
        case 'Sprite':
            var spriteId = tokens.takeInt();
            tokens.takeExpect(TokenType.COMMA);
            var spriteIndex = tokens.takeInt();
            tokens.takeExpect(TokenType.EXPR_END);
            return { type: 'sprite', spriteId: spriteId, spriteIndex: spriteIndex };
        case 'Item':
            var itemId = tokens.takeInt();
            tokens.takeExpect(TokenType.EXPR_END);
            return { type: 'itemId', itemId: itemId };
        case 'File':
            var filePath = tokens.takeString();
            tokens.takeExpect(TokenType.EXPR_END);
            return { type: 'file', filePath: filePath };
        case 'CurrentItem':
            tokens.takeExpect(TokenType.EXPR_END);
            return { type: 'current' };
        default:
            throw new TokenStreamError('unexpected icon expression', exprName);
    }
};
